import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from '@angular/router';
import { InvitationService } from "src/app/app/invitation/invitation.service";

@Injectable()
export class InvitationPublicResolver  {
    
    constructor(
        public invtationServ: InvitationService,
    ) {}

    resolve(route: ActivatedRouteSnapshot) {
        return this.invtationServ.getInvtationPublic(route.paramMap.get('qrcode'));
    }
}